import { getStepsIntl2Lw } from 'cohorts/intl_2lw/helpers/getFirstScreenVariant'
import { STEPS_MAP } from 'constants/steps-map'
import { Cohort } from 'root-constants'
import type { TStep } from 'src/types'

// Single source of truth for a cohort's active step list. intl_2lw resolves to
// either the default flow or the abtest_web_127_first_screen group C flow
// (depends on GrowthBook); every other cohort keeps its static steps.
export const getCohortSteps = (cohort: Cohort | string): TStep[] => {
  if (cohort === Cohort.INTL_2LW) return getStepsIntl2Lw()
  return STEPS_MAP[cohort as Cohort]
}
